import { ReactNode } from "react";

// Lightweight head shim - sets document.title only.
// Full SEO managed via static index.html for now.
export default function SeoHead({ title }: { title?: string; children?: ReactNode; description?: string; canonicalBase?: string; jsonLd?: any }) {
  if (typeof document !== "undefined" && title) {
    document.title = title;
  }
  return null;
}
